import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import {store} from "./reducers";
import {Router} from 'react-router-dom';
import {history} from "./_Utilities/History";
import ScrollToTop from './_Utilities/ScrollToTop';

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <ScrollToTop>
                <App/>
            </ScrollToTop>
        </Router>
    </Provider>,
    document.getElementById('root'));
registerServiceWorker();